import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const SocialLinks = makeShortcode("SocialLinks");
const FontAwesomeIcon = makeShortcode("FontAwesomeIcon");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div style={{
      textAlign: 'center'
    }}>
      <SocialLinks justifyContent='center' fontSize={40} mdxType="SocialLinks" />
      <p>&nbsp;</p>
      <div><a style={{
          "color": "currentColor"
        }} aria-label="RSS feed" href="/rss.xml"><FontAwesomeIcon icon={['fas', 'rss']} mdxType="FontAwesomeIcon" /></a> DavidMello.com © {new Date().getFullYear()}</div>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      